export default "__VITE_ASSET__DwCLbYji__"